import { useRef } from "react";
import { motion, useScroll, useTransform, useInView } from "framer-motion";

export const CatalinaBanner = () => {
  const ref = useRef(null);
  const textRef = useRef(null);
  const inView = useInView(textRef, { once: true, margin: "-15% 0px" });
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-14%", "14%"]);

  const line = (delay) => ({
    initial: { y: "110%" },
    animate: inView ? { y: "0%" } : { y: "110%" },
    transition: { duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] },
  });

  return (
    <section ref={ref} className="relative h-[62vh] md:h-[78vh] overflow-hidden grain" data-testid="catalina-banner">
      <motion.img
        src="/assets/catalina.png"
        alt="Catalina Island at sunset"
        style={{ y }}
        className="absolute inset-0 w-full h-[130%] object-cover -top-[15%]"
        data-testid="catalina-image"
      />
      <div className="absolute inset-0 bg-[#070A0F]/45" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#070A0F] via-transparent to-[#070A0F]" />
      <div ref={textRef} className="relative h-full max-w-7xl mx-auto px-5 md:px-8 flex flex-col items-center justify-center text-center">
        <div className="overflow-hidden py-1">
          <motion.p
            {...line(0)}
            className="text-xs md:text-sm tracking-[0.6em] uppercase text-[#F5F3EF]/85"
            data-testid="catalina-line-1"
          >
            It's more than a brand.
          </motion.p>
        </div>
        <div className="overflow-hidden py-1 mt-3">
          <motion.h2
            {...line(0.15)}
            className="font-display font-bold text-4xl sm:text-5xl lg:text-7xl tracking-[0.06em] gold-text"
            data-testid="catalina-line-2"
          >
            IT'S A WAY OF LIFE.
          </motion.h2>
        </div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
          className="font-coords text-[10px] md:text-xs tracking-[0.3em] text-[#F5F3EF]/60 mt-6"
          data-testid="catalina-coords"
        >
          CATALINA ISLAND · AVALON HARBOR · 33°20'46"N 118°19'32"W
        </motion.p>
      </div>
    </section>
  );
};
